import { request } from './utils';

export default class LenderService {
    static async getAll() {
        const response = await request('/lenders');
        return response.data;
    }
}